import styled , { css, keyframes } from 'styled-components';
import { assetPath } from '../../../utils/web-helper';
import * as C from '../../../components/loggedout/shared-styles/Colors';
import FontGraphie from '../../../components/loggedout/shared-styles/graphieFont';
import CustomDot from '~images/onboarding/custom-dot.svg';
import { DisplacementTransition } from '../../../components/loggedout/shared-styles/transitions';
import { device } from '../../../utils/responsive_utilities';

export const Container = styled.div`
  height: 100%;
  @media ${device.TabletLandscape}{
    margin-top: 2rem;
  }
  @media ${device.PhoneTabletLandscape}{
    overflow: auto;
  }
`

export const HeaderContainer = styled.div`
  @media ${device.PhoneTabletLandscape}{
    > p{
      ${FontGraphie(1.4, 1, 6)}
    }
  }
  @media ${device.Phone}{
    > h1, p{
      width: 80%;
      margin: 0 auto;
    }
  }
`

export const CustomPaginationDot = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  background: url(${assetPath(CustomDot)}) no-repeat;
`;

export const SliderWrapper = styled.div`
  padding-top: 8.4rem;
  width: 62%;
  margin: 0 auto;
  padding-left: 12rem;
  @media ${device.TabletLandscape}{
    width: 65%;
    padding-top: 11rem;
    padding-left: unset;
  }
  @media ${device.Tablet}{
    width: 80%;
    padding-top: 20.4rem;
    padding-left: unset;
  }
  @media ${device.PhoneTabletLandscape}{
    width: 65%;
    padding-top: 4rem;
    padding-left: unset;
  }
  @media ${device.Phone}{
    width: 87%;
    padding-top: 1.4rem;
    padding-left: unset;
  }

  ${(props) => DisplacementTransition({
    props: props,
    startY: '5rem', 
    time: 0.7,
  })}
  .slick-slide {
    opacity: 0;
    transition: opacity 0.2s;
    height: 38rem;
    position: relative;
    &.slick-current {
      opacity: 1;
    }
  }
  .slick-dots {
    pointer-events: ${(props) => props.isLPABTest? 'none':'unset'}; //so that the users can't skip questions
    transform: translate(-50%, -50%) rotate(90deg);
    top: calc(50% - 11rem);
    bottom: unset;
    left: 0;
    display: inline-flex;
    width: auto;
    @media ${device.PhoneTabletLandscape}{
        top: calc(50% - 9.5rem);
    }

    &:before {
      content: '';
      width: 5.8rem;
      height: 1.2rem;
      border-radius: 1.3rem;
      background-color: ${C.indigo};
      position: absolute;
      z-index: 1;
      left: ${props => props.activeDotMovementValue}px;
      top: 46%;
      transform: translate(0%, -50%);
      transition: all 0.2s;

      @media ${device.Phone}, ${device.PhoneTabletLandscape}{
        height: 1rem;
        width: 5.6rem;
      }

      @media ${device.PhoneTabletLandscape}{
        width: 4.6rem;
      }
    }
    > li {
      margin: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 2.6rem;
      &:nth-child(1n) {
        ${CustomPaginationDot} {
          transform: rotate(285deg);
          @media ${device.PhoneTabletLandscape}{
            transform: rotate(285deg) scale(0.8);
          }
        }
      }
      &:nth-child(2n) {
        ${CustomPaginationDot} {
          transform: rotate(285deg);
          @media ${device.PhoneTabletLandscape}{
            transform: rotate(285deg) scale(0.8);
          }
        }
      }
      &:nth-child(3n) {
        ${CustomPaginationDot} {
          transform: rotate(225deg);
          @media ${device.PhoneTabletLandscape}{
            transform: rotate(285deg) scale(0.8);
          }
        }
      }
      &:nth-child(4n) {
        ${CustomPaginationDot} {
          transform: rotate(225deg);
          @media ${device.PhoneTabletLandscape}{
            transform: rotate(285deg) scale(0.8);
          }
        }
      }
      &:nth-child(5n) {
        ${CustomPaginationDot} {
          transform: rotate(285deg);
          @media ${device.PhoneTabletLandscape}{
            transform: rotate(285deg) scale(0.8);
          }
        }
      }
      &.slick-active {
        width: 5.8rem;
        @media ${device.PhoneTabletLandscape}{
          width: 6.5rem;
        }
      }
      @media ${device.PhoneTabletLandscape}{
        width: 2rem;
      }
    }
  }

`;

export const ExampleText = styled.div`
  ${FontGraphie(2.4, 1.2, 7)}
  color: ${C.magenta};
  padding-right: 1.2rem;
  display: inline-flex;

  @media ${device.Phone}{
    ${FontGraphie(1.8, 1.2, 7)}
  }
  @media ${device.PhoneTabletLandscape}{
    ${FontGraphie(1.6, 1.2, 7)}
  }
`;

export const Question = styled.div`
  padding: 1rem;
  box-sizing: border-box;
  text-align: left;
  margin-left: 3.8rem;
  outline: none;
  @media ${device.Phone}, ${device.PhoneTabletLandscape}{
    margin-left: 2.5rem;
  }

  p {
    ${FontGraphie(2.4, 1.2, 7)}
    color: ${C.white};
    padding-bottom: 2rem;

    @media ${device.Phone}{
      ${FontGraphie(1.8, 1.2, 7)}
    }
    @media ${device.PhoneTabletLandscape}{
      ${FontGraphie(1.6, 1, 7)}
    }
  }
  span {
    ${FontGraphie(2.4, 1.2, 7)}
    color: ${C.magenta};
    padding-right: 1.2rem;
    @media ${device.Phone}{
      ${FontGraphie(1.8, 1.2, 7)}
    }
    @media ${device.PhoneTabletLandscape}{
      ${FontGraphie(1.6, 1.2, 7)}
    }
  }

  img {
    display: inline-block;
    height: 4.2rem;

    @media ${device.PhoneTabletLandscape}{
      height: 2.4rem
    }
    @media ${device.Phone}{
      height: 2.8rem
    }
  }
`;

export const ResponseWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 0.8rem;
  transform: translateY(${props => props.positiveShift ? '2rem': '-2rem' });
  opacity: 0;
  &.parallax {
    transition: all ease-in-out 1s ${props => props.currentIndex == 0 ? '2.5s' : '0.6s'};
    transform: translateY(0);
    opacity: 1;
  }
  @media ${device.Phone}{
    margin-top: 2rem; 
  }
  @media ${device.PhoneTabletLandscape}{
    margin-top: 3.5rem; 
  }
`;

export const Response = styled.li`
  display: flex;
  margin: 2rem 2rem 0 0;
  ${FontGraphie(2, 1.2, 6)}
  justify-content: center;
  align-items: center;
  border: 0.1rem solid ${C.white};
  border-radius: 3.2rem;
  color: ${C.white};
  padding: 1.2rem 2.8rem;
  cursor: pointer;
  &.success {
    background-color: ${C.Downy};
    border: 0.1rem solid ${C.Downy};
    color: ${C.white};
    transition: all 1s;
  }
  ${props => props.filled ? css`
    background-color: ${C.Downy};
    color: ${C.white};
    border: 0.1rem solid ${C.Downy};
  ` : null}

  @media ${device.Phone}{
    height: 4.8rem;
    ${FontGraphie(1.6, 1, 6)}
    padding: 0 2.3rem;
    margin: 1.5rem 1.2rem 0 0;
  }

  @media ${device.PhoneTabletLandscape}{
    height: 3.6rem;
    margin: 1.5rem 2.4rem 0 0;
    padding: 0 2.7rem;
    ${FontGraphie(1.3, 0.9, 6)}
  }
`;

export const ExampleWrapper = styled.div`
  transform: translateY(${props => props.positiveShift ? '2rem': '-2rem' });
  opacity: 0;
  &.parallax {
    transition: all ease-in-out 0.7s;
    transform: translateY(0);
    opacity: 1;
  }
`;

export const SkipPersonalisationCTA = styled.span`
  position: absolute;
  top: -3.6rem;
  right: 4.2rem;
  text-decoration: underline;
  color: ${C.CornflowerBlue};
  ${FontGraphie(1.6, 1.2, 7)}
  cursor: pointer;
  ${(props) => DisplacementTransition({
    props: props,
    startY: '5rem',
    time: 0.7, 
  })}
  @media ${device.TabletLandscape}{
    top: -4.5rem;
    right: 4rem;
  }
  @media ${device.Tablet}{
    left: 0;
    right: 0;
    top: unset;
    width: auto;
    margin: auto;
  }
  @media ${device.PhoneTabletLandscape}{
    bottom: 2.2rem;
    right: 1.4rem;
    left: unset;
    top: unset;
    ${FontGraphie(1.4, 1, 4)}
  }
  @media ${device.Phone}{
    left: 50%;
    bottom: 2rem;
    top: unset;
    right:unset;
    transform: translateX(-50%);
    ${FontGraphie(1.4, 1, 4)}
  }
`;